import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function isFormGroup(obj: UntypedFormGroup | UntypedFormArray): obj is UntypedFormGroup {
    return obj instanceof UntypedFormGroup;
}
